<template>
  <v-row no-gutters
         class="card-container std-container-shadow std-pointer std-border-radius"
         :style="{maxWidth: width, height: height, minWidth: width}">
    <div class="std-text-white-1 inline-flex title-container d-flex std-text-md align-center justify-center font-weight-bold"
         :style="{backgroundColor: titleBackground, width: leftPercent}">
      {{title}}
    </div>
    <div class="std-text-white-1 inline-flex number-container d-flex align-center justify-center std-text-md font-weight-bold"
         :style="{backgroundColor: numberBackground, width: rightPercent}">
      {{number}}
    </div>
  </v-row>
</template>

<script>
    export default {
        name: "SystemCardCount",
        props: ['width', 'height', 'title', 'number', 'titleBackground', 'numberBackground', 'leftPercent', 'rightPercent'],
        data: () => {
            return {
            }
        }
    }
</script>

<style scoped>
  .card-container {
    display: inline-flex !important;
  }

  .title-container {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    width: 75%;
  }

  .number-container {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    width: 25%;
  }
</style>